/*
* CarSelectorReducer
*/

import { fromJS } from 'immutable';
import {
  GET_BRANDS,
  MODELS_RECEIVED,
  BRANDS_ERROR,
  BRANDS_RECEIVED,
  MODELS_ERROR,
  BRAND_SELECTED,
  VERSIONS_RECEIVED,
  VERSIONS_ERROR,
  MODEL_SELECTED,
  VERSION_SELECTED,
  CAR_ERROR,
  CAR_RECEIVED,
  CAR_IMAGES_ERROR,
  GET_CAR_IMAGES,
  CAR_IMAGES_RECEIVED,
  CAR_IMAGES_NEW,
  RESET,
} from './constants';
import {
  UPLOAD_REQUEST,
  UPLOAD_SUCCESS,
  UPLOAD_FAILURE,
  SET_MAIN,
  SET_MAIN_SUCCESS,
  DELETE_SUCCESS,
  DELETE_ALL_SUCCESS,
  DOWNLOAD_CAR_IMAGES_REQUEST,
  DOWNLOAD_CAR_IMAGES_SUCCESS,
} from '../CarImages/constants'

export const initialState = fromJS({
  brands: [],
  models: [],
  versions: [],
  car: fromJS({}),
  images: {
    default: [],
    custom: [],
  },
  selectedBrand: null,
  selectedModel: null,
  selectedModelName: "",
  selectedModelYear: "",
  selectedVersion: null,
  error: null,
  loading: false,
  downloadLoading: false,
});

function carSelectorReducer(state = initialState, action) {
  switch (action.type) {
    case GET_BRANDS:
    case GET_CAR_IMAGES:
    case UPLOAD_REQUEST:
    case SET_MAIN:
      return state.set('loading', true);
    case DOWNLOAD_CAR_IMAGES_REQUEST:
      return state.set('downloadLoading', true);
    case BRAND_SELECTED:
      return state
        .set('selectedBrand', action.selectedBrand)
        .set('models', [])
        .set('selectedModel', null)
        .set('selectedModelName', "")
        .set('selectedVersion', null)
        .set('versions', [])
        .set('loading', true);
    case MODEL_SELECTED:
      return state
        .set('selectedModel', action.selectedModel)
        .set('selectedModelName', action.selectedModelName)
        .set('selectedModelYear', action.selectedModelYear)
        .set('selectedVersion', null)
        .set('versions', [])
        .set('loading', true);
    case VERSION_SELECTED:
      return state.set('selectedVersion', action.selectedVersion);
    // Responses
    case CAR_IMAGES_RECEIVED:
      const receivedImages = action.images;
      let currentStateImages = state.get('images');
      if (currentStateImages.hasOwnProperty('__altered')) {
        currentStateImages = currentStateImages.toJS();
      }

      let imagesToSet = {
        default: currentStateImages.default,
        custom: currentStateImages.custom
      }

      if (typeof receivedImages.custom !== 'undefined' && receivedImages.custom.length >= 0) {
        imagesToSet.custom = receivedImages.custom;
      }
      if (typeof receivedImages.default !== 'undefined' && receivedImages.default.length >= 0) {
        imagesToSet.default = receivedImages.default;
      }

      return state.set('images', imagesToSet);
    case CAR_IMAGES_NEW:
      const images = state.get('images');
      return state.set('images', {default: images.default, custom: [...images.custom, ...action.images]});
    case DELETE_SUCCESS:
      let currentImages = state.get('images');
      const newCustomImages = currentImages.custom.filter(image => image.id !== action.imageId);
      return state.set('images', {default: currentImages.default, custom: [...newCustomImages]});
    case DELETE_ALL_SUCCESS:
      return state.set('images', {default: state.get('images').default, custom: []});
    case MODELS_RECEIVED:
      return state
        .set('models', action.models)
        .set('loading', false)
        .set('error', null);
    case BRANDS_RECEIVED:
      return state
        .set('brands', action.brands)
        .set('loading', false)
        .set('error', null);
    case VERSIONS_RECEIVED:
      return state
        .set('versions', action.versions)
        .set('loading', false)
        .set('error', null);
    case CAR_RECEIVED:
      return state
        .set('car', fromJS(action.car))
        .set('loading', false)
        .set('error', null);
    // Errors
    case BRANDS_ERROR:
      return state
        .set('brands', [])
        .set('loading', false)
        .set('error', action.error);
    case MODELS_ERROR:
      return state
        .set('models', [])
        .set('loading', false)
        .set('error', action.error);
    case VERSIONS_ERROR:
      return state
        .set('versions', [])
        .set('loading', false)
        .set('error', action.error);
    case CAR_ERROR:
      return state
        .set('car', null)
        .set('loading', false)
        .set('error', action.error);
    case CAR_IMAGES_ERROR:
      return state
        .set('images', [])
        .set('loading', false)
        .set('error', action.error);
    case UPLOAD_SUCCESS:
    case UPLOAD_FAILURE:
    case SET_MAIN_SUCCESS:
      return state.set('loading', false);
    case DOWNLOAD_CAR_IMAGES_SUCCESS:
      return state.set('downloadLoading', false);
    case RESET:
      return initialState;
    default:
      return state;
  }
}

export default carSelectorReducer;
